import React from 'react';
import { BookOpen, Activity, Heart } from 'lucide-react';
export function AuthorSection() {
  return <section className="py-12 px-4 bg-[#FDF0F3] border-y border-[#E2E8F0]" data-id="element-29">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-30">
        <div className="inline-flex items-center justify-center p-3 bg-white rounded-full mb-6 shadow-sm text-[#B83A52]" data-id="element-31">
          <Activity className="w-6 h-6" data-id="element-32" />
        </div>

        <h3 className="text-2xl font-serif font-bold text-[#1C1C2E] mb-6" data-id="element-33">
          Por qué esto funciona
        </h3>

        <div className="bg-white p-8 rounded-xl border border-[#E2E8F0] shadow-sm relative" data-id="element-34">
          <p className="text-lg font-serif italic text-[#1B3A6B] leading-relaxed mb-6" data-id="element-35">
            "El 40% de los cuidadores de pacientes oncológicos desarrollan
            depresión clínica durante el proceso. No porque no amen. Sino porque
            nadie les enseñó a cuidar mientras cuidan."
          </p>
          <p className="text-xs font-bold text-[#8B8BAA] uppercase tracking-wider" data-id="element-36">
            — DATO: ORGANIZACIÓN MUNDIAL DE LA SALUD
          </p>
        </div>

        <p className="text-[#4A4A6A] mt-8 max-w-2xl mx-auto" data-id="element-37">
          Esta guía no es teoría abstracta. Está basada en principios de{' '}
          <span className="font-bold text-[#1B3A6B]" data-id="element-38">psicooncología</span> y en
          la experiencia real de miles de familias que han atravesado este
          camino antes que tú.
        </p>
      </div>
    </section>;
}